<template>
  <div class="home">
    <div class="sql-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 120" width="96" height="120">
        <defs>
          <clipPath id="corner-clip">
            <path d="M61,0 L96,35 L96,120 L0,120 L0,0 z" />
          </clipPath>
        </defs>
        <rect x="0" y="0" width="96" height="120" fill="#FF9100" rx="10" ry="10" clip-path="url(#corner-clip)" />
        <path d="M61,0 L96,35 L71,35 A10,10 0 0,1 61,25 Z" fill="#B200FF" />
        <text x="48" y="86" font-family="Verdana, sans-serif" font-size="30" font-weight="bold" fill="#B200FF" text-anchor="middle">SQL</text>
      </svg>
    </div>
    <h1>Welcome to SQL Query Formatter</h1>
    <p class="mt-4">
      This tool helps you format your SQL queries for better readability and consistency.
      Whether you're a database administrator, developer, or data analyst, our formatter
      can help you make your queries more manageable and easier to understand.
    </p>
    <div class="mt-5">
      <h2>Key Features:</h2>
      <ul class="list-unstyled">
        <li><i class="bi bi-check-circle-fill text-success"></i> Support for multiple SQL dialects</li>
        <li><i class="bi bi-check-circle-fill text-success"></i> Customizable formatting options</li>
        <li><i class="bi bi-check-circle-fill text-success"></i> Easy-to-use interface</li>
        <li><i class="bi bi-check-circle-fill text-success"></i> Instant formatting results</li>
      </ul>
    </div>
    <TrySqlFormatterButton />
  </div>
  <AppFooter />
</template>

<script>
import TrySqlFormatterButton from "@/components/TrySqlFormatterButton.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: 'HomePage',
  components: {
    AppFooter,
    TrySqlFormatterButton,
  }
}
</script>

<style scoped>
.home {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 20px 80px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.sql-icon {
  margin-bottom: 20px;
}

ul {
  display: inline-block;
  text-align: left;
}

li {
  margin-bottom: 10px;
}

.bi {
  margin-right: 10px;
}

.text-success {
  color: #9A33CC !important;
}

.empty-footer {
  width: 100%;
  height: 60px;
}
</style>
